module.exports = __webpack_public_path__ + "static/media/tz.88c89454.svg";